import React, { useState } from 'react';
import { Download, FileText, Table as TableIcon, BarChart3 } from 'lucide-react';
import { PageHeader } from '../components/ui/page-header';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Select } from '../components/ui/select';
import { Alert, AlertDescription } from '../components/ui/alert';

function ReportsPage() {
  const [reportType, setReportType] = useState('daily');
  const [format, setFormat] = useState('pdf');

  const handleExport = async () => {
    // eslint-disable-next-line no-alert
    alert(`Exporting ${reportType} report as ${format.toUpperCase()}`);
  };

  return (
    <div className="mx-auto flex max-w-[1400px] flex-col gap-6">
      <PageHeader
        title="Reports & Export"
        description="Generate and export monitoring reports."
      />

      <div className="grid gap-4 md:grid-cols-2">
        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-base">Generate Report</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="space-y-1.5">
              <label className="text-sm font-medium text-foreground">Report Type</label>
              <Select
                value={reportType}
                onChange={(e) => setReportType(e.target.value)}
              >
                <option value="daily">Daily Summary</option>
                <option value="weekly">Weekly Report</option>
                <option value="monthly">Monthly Overview</option>
                <option value="custom">Custom Range</option>
              </Select>
            </div>

            <div className="space-y-1.5">
              <label className="text-sm font-medium text-foreground">Format</label>
              <Select value={format} onChange={(e) => setFormat(e.target.value)}>
                <option value="pdf">PDF Document</option>
                <option value="csv">CSV Spreadsheet</option>
                <option value="json">JSON Data</option>
              </Select>
            </div>

            <Button className="w-full" onClick={handleExport}>
              <Download />
              Export Report
            </Button>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-base">Quick Exports</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            <Button variant="outline" className="w-full">
              <FileText />
              Today's Incidents (PDF)
            </Button>
            <Button variant="outline" className="w-full">
              <TableIcon />
              All Screenshots (CSV)
            </Button>
            <Button variant="outline" className="w-full">
              <BarChart3 />
              Risk Analysis (PDF)
            </Button>

            <Alert variant="info">
              <AlertDescription>
                Reports include all monitoring data for the selected period.
              </AlertDescription>
            </Alert>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

export default ReportsPage;
